import type { RouteRecordRaw } from 'vue-router'

const settingsRouteNames = {
  settingsProfile: 'settingsProfile'
}

const settingsRoutes: RouteRecordRaw[] = [
  {
    path: 'profile',
    name: settingsRouteNames.settingsProfile,
    component: () => import('@/views/settings/UserProfile.vue')
  }
]

export {
  settingsRouteNames,
  settingsRoutes
}
